const getISOFormattedTimestamp = (date) => {
	const tzoffset = (date || new Date()).getTimezoneOffset() * 60000 // offset in milliseconds
	return (new Date((date || Date.now()) - tzoffset)).toISOString().slice(0, -5)
}

module.exports = getISOFormattedTimestamp



// WEBPACK FOOTER //
// ./src/utilities/getISOFormattedTimestamp.js